// "Flight details" card of a ShareJet booking: IDs, status, ad-hoc labels, MGAV progress, seats.
import type { ReactNode } from 'react';
import { Card, Descriptions, Progress, Space, Tag, Typography } from 'antd';

import type { AdminBookingDetail } from '../../api/types';
import { BOOKING_STATUS_COLORS, BOOKING_STATUS_LABELS, statusLabel } from '../../data/statuses';
import { mgavLabel, mgavPercent } from '../../data/mgav';

const { Text } = Typography;

export function FlightDetailsCard({
  b,
  extra,
  adhocTags,
}: {
  b: AdminBookingDetail;
  extra: ReactNode;
  adhocTags: ReactNode;
}) {
  const pct = mgavPercent(b.mgavProgress);
  const mgavTxt = mgavLabel(b.mgavProgress);
  return (
    <Card title="Flight details" extra={extra}>
      <Descriptions column={{ xs: 1, sm: 2 }} bordered size="small">
        <Descriptions.Item label="Booking ID">
          <Text code>{b.id}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Flight ID">{b.flightNumber || '—'}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Tag color={BOOKING_STATUS_COLORS[b.status]}>{statusLabel(BOOKING_STATUS_LABELS, b.status, b.statusLabel)}</Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Ad-hoc status">{adhocTags}</Descriptions.Item>
        <Descriptions.Item label="MGAV progress">
          {pct != null ? (
            <Space>
              <Progress
                percent={pct}
                size="small"
                style={{ width: 140 }}
                status={b.mgavOverdue ? 'exception' : pct >= 100 ? 'success' : 'active'}
              />
              {mgavTxt ? <Text type="secondary">{mgavTxt}</Text> : null}
            </Space>
          ) : (
            <Text type="secondary">{mgavTxt || '—'}</Text>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Seats booked">
          {b.seatsBooked} / {b.seatsTotal}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
